// extracted by mini-css-extract-plugin
module.exports = {"Msg":"NoResultsMessage_Msg__3xwS8"};